import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-dias-libres',
  templateUrl: './main-dias-libres.component.html',
  styleUrls: ['./main-dias-libres.component.css']
})
export class MainDiasLibresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
